<template>
    <div class="w-full flex justify-between items-center mb-6">
        <div class="font-bold tracking-tight" :class="{ 'text-2xl md:text-3xl': importance == 1 || !importance, 'text-2xl': importance == 2, 'text-xl': importance == 3}">
            {{ title }}
        </div>
        <div class="">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'title', 'importance' ]
}
</script>
